// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
import api from './api/api'
import 'github-markdown-css/github-markdown.css'

Vue.use(VueMeta)

Vue.prototype.$api = api; // 将api挂载到vue的原型上

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js